<div class="unauthorized-container">
  <h1>Not Authorized</h1>
  <p>You do not have sufficient permission to view this page.</p>
  <a routerLink="/" class="back-home">Go to Home</a>
</div>